/**
 * Parked features — one switch per feature, hardcoded off.
 *
 * Nothing is deleted: every component, route and API call still exists. Flip a
 * value to `true` here (and the matching flag in backend/utils/parked.py for
 * anything that spends money) to bring the feature back.
 */

/** AI voice calling: autodialer, call campaigns, call buttons, voice settings. */
export const VOICE_CALLING_ENABLED = false;

/** Bulk-paste LinkedIn Recruiter URLs tool on the Jobs page. */
export const LINKEDIN_BULK_URLS_ENABLED = false;
